import { Buffer } from 'buffer';
import { ChatContextType } from '../../enums/chat.js';
import type { Chat, BrandInsightsInstanceContext } from '../../types/index.js';
import type { ChatInstances } from '../interfaces/index.js';
import { safeJsonDateRequired } from './date.js';
import { transformChatFileUpload } from './file-upload.js';
import { transformKolSearchResult } from './kol.js';
import { transformChatQuery } from './query.js';

export function transformChatInstance(data: Chat.Instance<string>): Chat.Instance<Date> {
  return {
    ...data,
    context: transformChatInstanceContext(data.context),
    createdOn: safeJsonDateRequired(data.createdOn),
  };
}

export function transformChatInstanceContext(data: Chat.InstanceContextWithMetadata<string>): Chat.InstanceContextWithMetadata<Date> {
  switch (data.type) {
    case ChatContextType.Transcript: {
      return {
        ...data,
        metadata: {
          ...data.metadata,
          date: safeJsonDateRequired(data.metadata.date),
        },
      };
    }
    default: return data;
  }
}

export function transformChatSession(data: ChatInstances.GetChatInstance.Response): Chat.Session {
  return {
    chatInstance: transformChatInstance(data.chatInstance),
    queries: data.queries.reduce<Record<string, Chat.Query>>((queries, query) => {
      queries[query.identifier] = transformChatQuery(query);
      return queries;
    }, {}),
    fileUploads: data.fileUploads.map(transformChatFileUpload),
    kolSearches: data.kolSearches.map(transformKolSearchResult),
  };
}

export function transformChatShareableUsers(data: ChatInstances.GetChatShareableUsers.Response): Chat.User[] {
  return data.items;
}

export function prepareContextData(data: BrandInsightsInstanceContext.ItemWithMetadata): BrandInsightsInstanceContext.Item {
  const { metadata, ...ctx } = data;
  return ctx;
}

export function stringifyContextData(data: BrandInsightsInstanceContext.Item): string {
  return Buffer.from(JSON.stringify(data)).toString('base64');
}